module.exports = __webpack_public_path__ + "media/flags/py-8b7bf512.svg";